<script>
export default {
    name: "PaymentUpdateModal",
    props: {
        request: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isUpdating: false,
        };
    },
    computed: {
        requestId() {
            return this.request.id;
        },
        modalId() {
            return `payment-update-modal-${this.requestId}`;
        },
        isPaid() {
            return this.getRequestPaidStatus(this.request);
        },
        isDisabled() {
            return this.request.head_hunting === 1;
        },
    },
    methods: {
        showModal() {
            this.$refs[`payment-modal-${this.requestId}`].show();
        },
        hideModal() {
            this.$refs[`payment-modal-${this.requestId}`].hide();
        },
        getRequestPaidStatus(request) {
            return request.paid === 1;
        },
        setPaymentStatus(request) {
            const status = request.paid === 1 ? 0 : 1;
            const requestId = request.id;
            const paymentUrl = document.getElementById(`payment-url-${requestId}`).value;

            this.isUpdating = true;

            this.$store.dispatch("credit/updateRequestStatus", {
                requestId: requestId,
                status: status,
                paymentUrl: paymentUrl,
            }).then((response) => {
                alert("Payment updated successfully");
            }).catch((error) => {
                console.log(error);
                alert("Something went wrong");
            }).finally(async () => {
                this.isUpdating = false;
                this.$emit("payment-updated");
                this.hideModal();
            });
        },
    },
};
</script>

<template>
  <div>
    <button
      type="button"
      :class="`btn ${isPaid ? 'btn-primary' : 'btn-outline-primary' }`"
      :disabled="isDisabled"
      @click="showModal"
    >
      {{ isPaid ? "Payment Updated" : "Update Payment" }}
    </button>

    <b-modal
      :id="modalId"
      :ref="`payment-modal-${request.id}`"
      title="Update Payment"
    >
      <template #modal-header="{ close }">
        <h5>Update Payment</h5>
        <button
          type="button"
          class="btn-close"
          @click="close()"
        />
      </template>
      <b-container>
        <div class="input-group">
          <input
            :id="`payment-url-${request.id}`"
            :value="request.payment_url"
            type="text"
            class="form-control"
            placeholder="Payment URL"
            aria-label="Payment URL"
            aria-describedby="button-payment-url"
          >
          <button
            :class="`btn ${getRequestPaidStatus(request) ? 'btn-success' : 'btn-info'}`"
            :disabled="isUpdating"
            @click="setPaymentStatus(request)"
          >
            {{ isPaid ? "Undo" : "Paid" }}
            <span
              v-if="isUpdating"
              class="spinner-grow spinner-grow-sm"
              role="status"
              aria-hidden="true"
            />
          </button>
        </div>
      </b-container>

      <template #modal-footer="{ cancel }">
        <button
          type="button"
          class="btn btn-secondary"
          @click="cancel()"
        >
          Close
        </button>
      </template>
    </b-modal>
  </div>
</template>
<style scoped>
:slotted(button.close) {
    padding: 0;
    background-color: transparent;
    border: 0;
}
</style>
